import React, { useContext } from 'react';
import AppContainer from 'containers/AppContainer';
import Header from 'components/Header';
import Content from 'components/Content';
import Footer from 'components/Footer';
import Button from 'components/Button';
import MessageWithGif from 'components/MessageWithGif';
import { useNavigate } from 'react-router';
import { LocaleContext } from 'containers/LocaleContext';
export function PageNotFound() {
    const { I18n } = useContext(LocaleContext);
    const navigate = useNavigate();
    const handleSubmit = () => {
        navigate('../');
    };
    return (React.createElement(AppContainer, null,
        React.createElement(Header, null),
        React.createElement(Content.Wrapper, null,
            React.createElement(Content.Base, { padded: true },
                React.createElement(MessageWithGif, { title: I18n.t('page_not_found.title'), text: I18n.t('page_not_found.text'), gifUrl: require('../assets/gifs/page_not_found.gif') }))),
        React.createElement(Footer, null,
            React.createElement(Button, { onClick: handleSubmit }, I18n.t('buttons.go_to_main_page')))));
}
